import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import NopePrimitive from './NopePrimitive';

var NopeBoolean = /*#__PURE__*/function (_NopePrimitive) {
  _inherits(NopeBoolean, _NopePrimitive);

  var _super = _createSuper(NopeBoolean);

  function NopeBoolean() {
    var _this;

    _classCallCheck(this, NopeBoolean);

    _this = _super.apply(this, arguments);
    _this._type = 'boolean';
    return _this;
  }

  _createClass(NopeBoolean, [{
    key: "true",
    value: function _true() {
      var _this2 = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input must be true';

      var rule = function rule(entry) {
        if (_this2.isEmpty(entry)) {
          return;
        }

        if (entry !== true) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "false",
    value: function _false() {
      var _this3 = this;

      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input must be false';

      var rule = function rule(entry) {
        if (_this3.isEmpty(entry)) {
          return;
        }

        if (entry !== false) {
          return message;
        }
      };

      return this.test(rule);
    }
  }, {
    key: "validate",
    value: function validate(entry, context) {
      var value = entry === undefined || entry === null ? entry : !!entry;
      return _get(_getPrototypeOf(NopeBoolean.prototype), "validate", this).call(this, value, context);
    }
  }]);

  return NopeBoolean;
}(NopePrimitive);

export default NopeBoolean;